export default window.QD_ADMIN_COMMON?.LoginCommon;
